// ============================================================
// Wauvea WebXR — Video Controls
// Play/pause, seek, volume, fullscreen
// ============================================================

export class VideoControls {
  constructor(mainScreen) {
    this.mainScreen = mainScreen;
    this.container = document.getElementById('video-controls');
    this.btnPlay = document.getElementById('btn-play-pause');
    this.iconPlay = document.getElementById('icon-play');
    this.iconPause = document.getElementById('icon-pause');
    this.btnVolume = document.getElementById('btn-volume');
    this.iconVolOn = document.getElementById('icon-vol-on');
    this.iconVolOff = document.getElementById('icon-vol-off');
    this.btnFullscreen = document.getElementById('btn-fullscreen');
    this.progressWrapper = document.getElementById('progress-wrapper');
    this.progressFill = document.getElementById('video-progress-fill');
    this.timeDisplay = document.getElementById('time-display');

    this._bind();
  }

  _bind() {
    // Play/Pause
    this.btnPlay?.addEventListener('click', (e) => {
      e.stopPropagation();
      this.mainScreen.togglePlay();
      this._updatePlayIcon();
    });

    // Volume
    this.btnVolume?.addEventListener('click', (e) => {
      e.stopPropagation();
      this.mainScreen.toggleMute();
      this._updateVolumeIcon();
    });

    // Fullscreen
    this.btnFullscreen?.addEventListener('click', (e) => {
      e.stopPropagation();
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    });

    // Seek
    this.progressWrapper?.addEventListener('click', (e) => {
      e.stopPropagation();
      const rect = this.progressWrapper.getBoundingClientRect();
      const fraction = (e.clientX - rect.left) / rect.width;
      this.mainScreen.seek(fraction);
    });

    // Time update
    if (this.mainScreen.videoElement) {
      this.mainScreen.videoElement.addEventListener('timeupdate', () => {
        this._updateProgress();
      });
    }
  }

  show() {
    this.container?.classList.add('visible');
  }

  _updatePlayIcon() {
    const playing = this.mainScreen.isPlaying;
    if (this.iconPlay) this.iconPlay.style.display = playing ? 'none' : 'block';
    if (this.iconPause) this.iconPause.style.display = playing ? 'block' : 'none';
  }

  _updateVolumeIcon() {
    const muted = this.mainScreen.isMuted;
    if (this.iconVolOn) this.iconVolOn.style.display = muted ? 'none' : 'block';
    if (this.iconVolOff) this.iconVolOff.style.display = muted ? 'block' : 'none';
  }

  _updateProgress() {
    const { currentTime, duration } = this.mainScreen;
    if (duration && this.progressFill) {
      this.progressFill.style.width = `${(currentTime / duration) * 100}%`;
    }
    if (this.timeDisplay) {
      this.timeDisplay.textContent = `${this._fmt(currentTime)} / ${this._fmt(duration)}`;
    }
  }

  _fmt(seconds) {
    if (isNaN(seconds)) return '0:00';
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  }
}
